import React from 'react';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import './App.css';
import { useAuth, AuthProvider } from './AuthContext/AuthContext';
import Header from './Header/Header';
import Login from './Login/Login';
import Loginf from './Loginfake/Login';
import Register from './Register/Register';
import Admin from './Admin/Admin';
import Excepcion from './Excepcion/Excepcion';
import CampanaInfo from './CampanaInfo/CampanaInfo';
import CandidatoInfo from './CandidatoInfo/CandidatoInfo';
import Transmision from './Transmision/Transmision';
import NewCampain from './NewCampain/NewCampain';
import Audit from './Audit/Audit';
import Live from './Live/Live';

const routes = [
  { path: '/loginguadalupana', component: () => <LoginPage isFake /> },
  { path: '/login', component: () => <LoginPage /> },
  { path: '/', component: () => <LoginPage /> },
  { path: '/registro', component: () => <HeaderWrapper><Register /></HeaderWrapper> },
  { path: '/live', component: () => <Live /> },
  { path: '/campana', component: () => <ProtectedRoute component={CampanaInfo} allowedStatus={0} /> },
  { path: '/candidatos/:id', component: () => <ProtectedRoute component={CandidatoInfo} allowedStatus={0} /> },
  { path: '/transmision', component: () => <ProtectedRoute component={Transmision} allowedStatus={0} /> },
  { path: '/audit', component: () => <ProtectedRoute component={Audit} allowedStatus={2} withHeader /> },
  { path: '/admin', component: () => <ProtectedRoute component={Admin} allowedStatus={1} /> },
  { path: '/newcampana', component: () => <ProtectedRoute component={NewCampain} allowedStatus={1} /> },
  { path: '*', component: () => <HeaderWrapper><Excepcion /></HeaderWrapper> }
];

function App() {
  return (
    <React.StrictMode>
      <AuthProvider>
        <Router>
          <Switch>
            {routes.map((route, i) => (
              <Route key={i} exact path={route.path} component={route.component} />
            ))}
          </Switch>
        </Router>
      </AuthProvider>
    </React.StrictMode>
  );
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function LoginPage({ isFake = false }) {
  const query = useQuery();
  const bgId = parseInt(query.get('bgId'), 10) || 1; // Valor por defecto: 1
  return (
    <>
      {isFake ? <Loginf bgId={bgId} /> : <Login bgId={bgId} />}
    </>
  );
}

function HeaderWrapper({ children }) {
  return (
    <div>
      <Header />
      {children}
    </div>
  );
}

function ProtectedRoute({ component: Component, allowedStatus, withHeader = false }) {
  const { dispatch } = useAuth();
  const isAuthenticated = dispatch?.isAuthenticated && dispatch.status === allowedStatus;

  if (!isAuthenticated) {
    return <HeaderWrapper><Excepcion /></HeaderWrapper>;
  }

  return withHeader ? <HeaderWrapper><Component /></HeaderWrapper> : <Component />;
}

export default App;
